import axios from 'axios';
import * as Constants from '../common/constants';
import * as HelperFunctions from '../common/functions/helperFunctions';
import { MedicineFilterSettings } from "../models/medicineFilterSettings";

class MedicineService {

	constructor(lang?) {
		axios.defaults.baseURL = `${Constants.apiUrl}/`;
		axios.defaults.headers = {
			"Content-Type": "application/json; charset=utf-8",
			Pragma: 'no-cache',
			"langId": HelperFunctions.getLangId(lang)
		}
	}

	getAllMedicine() {
		return axios({
			url: `medicine/getAllMeds/`,
			method: 'get', headers: {
				"Content-Type": "application/json; charset=utf-8"
			}
		})
			.then(res => res.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getAllMedicines(from: number, numberOfRows: number, medicineSettings: MedicineFilterSettings, lang: string, seenCount: boolean = false) {
		return axios({
			url: `medicine/getAllList/${from}/${numberOfRows}/${seenCount}`,
			method: 'post',
			headers: {
				"Content-Type": "application/json; charset=utf-8",
				Pragma: 'no-cache',
				"langId": HelperFunctions.getLangId(lang)
			},
			data: JSON.stringify(medicineSettings)
		})
			.then(res => res.data.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getMedicineBasic(id: number, lang: string) {
		return axios({
			url: `medicine/getMedBasicById/${id}`,
			method: 'get',
			headers: {
				"Content-Type": "application/json; charset=utf-8",
				Pragma: 'no-cache',
				"langId": HelperFunctions.getLangId(lang)
			}
		})
			.then(res => res.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getMedicine(id: number, lang: string) {
		return axios({
			url: `medicine/getMedById/${id}`,
			method: 'get',
			headers: {
				"Content-Type": "application/json; charset=utf-8",
				Pragma: 'no-cache',
				"langId": HelperFunctions.getLangId(lang)
			}
		})
			.then(res => res.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getSideEffects(id: number, lang: string) {
		return axios({
			url: `medicine/getSideEffects/${id}`,
			method: 'get',
			headers: {
				"Content-Type": "application/json; charset=utf-8",
				Pragma: 'no-cache',
				"langId": HelperFunctions.getLangId(lang)
			}
		})
			.then(res => res.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getDosageContent(id: number, lang: string) {
		return axios({
			url: `medicine/getDosage/${id}`,
			method: 'get',
			headers: {
				"Content-Type": "application/json; charset=utf-8",
				Pragma: 'no-cache',
				"langId": HelperFunctions.getLangId(lang)
			}
		})
			.then(res => res.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getInteractionsCountsFull(id: number) {
		return axios({
			url: `medicine/fullIntrCount/${id}`,
			method: 'get'
		})
			.then(res => res.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getInteractionsCountsBasic(id: number, lang: string) {
		return axios({
			url: `medicine/basicIntrCount/${id}`,
			method: 'get',
			headers: {
				"Content-Type": "application/json; charset=utf-8",
				Pragma: 'no-cache',
				"langId": HelperFunctions.getLangId(lang)
			}
		})
			.then(res => res.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getDrugToDrugData(id: number, lang: string, from: number, numberOfRows: number) {
		return axios({
			url: `medicine/getDrugToDrugData/${id}/${from}/${numberOfRows}`,
			method: 'get',
			headers: {
				"Content-Type": "application/json; charset=utf-8",
				Pragma: 'no-cache',
				"langId": HelperFunctions.getLangId(lang)
			}
		})
			.then(res => res.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getDrugToFoodData(id: number) {
		return axios({
			url: `medicine/getDrugToFoodData/${id}`,
			method: 'get'
		})
			.then(res => res.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getDrugToDriveData(id: number) {
		return axios({
			url: `medicine/getDrugToDriveData/${id}`,
			method: 'get'
		})
			.then(res => res.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}


	getDrugToDiseaseData(id: number, lang: string) {
		return axios({
			url: `medicine/getDrugToDiseaseData/${id}`,
			method: 'get',
			headers: {
				"langId": HelperFunctions.getLangId(lang)
			}
		})
			.then(res => res.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getDrugToDrug(firstId: number, typeId: number, secondId: number) {
		return axios({
			url: `medicine/getDrugToDrug/${firstId}/${typeId}/${secondId}`,
			method: 'get'
		})
			.then(res => res.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getProfessionalContent(id: number, lang: string) {
		return axios({
			url: `medicine/getProfessional/${id}`,
			method: 'get',
			headers: {
				"langId": HelperFunctions.getLangId(lang)
			}
		})
			.then(res => res.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getPregnancyContent(id: number, lang: string) {
		return axios({
			url: `medicine/getPregnancy/${id}`,
			method: 'get',
			headers: {
				"langId": HelperFunctions.getLangId(lang)
			}
		})
			.then(res => res.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

	getDriveMachineContent(id: number, lang: string) {
		return axios({
			url: `medicine/getDriveMachine/${id}`,
			method: 'get',
			headers: {
				"langId": HelperFunctions.getLangId(lang)
			}
		})
			.then(res => res.data)
			.catch(error =>
				Promise.reject(HelperFunctions.getErrorMessage(error))
			)
	}

}

export default MedicineService;
